import { render, staticRenderFns } from "./priceElectricity.vue?vue&type=template&id=ecc9567a&scoped=true"
import script from "./priceElectricity.vue?vue&type=script&lang=js"
export * from "./priceElectricity.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/table.css?vue&type=style&index=0&id=ecc9567a&prod&scoped=true&lang=css&external"
import style1 from "./priceElectricity.vue?vue&type=style&index=1&id=ecc9567a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc9567a",
  null
  
)

export default component.exports